"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseButtonMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _focusMixin = require("../focusMixin");
var _spaceMixin = require("../spaceMixin");
/** @class CloseButtonMixin */
/** @method */
var CloseButtonMixin = function CloseButtonMixin(props) {
  return (0, _styledToken.default)({
    buttonSize: 'CloseButton.buttonSize',
    iconColor: 'CloseButton.iconColor',
    backgroundColor: 'CloseButton.backgroundColor',
    borderRadius: 'CloseButton.borderRadius',
    padding: 'CloseButton.padding',
    margin: 'CloseButton.margin'
  }, function (_ref) {
    var buttonSize = _ref.buttonSize,
      iconColor = _ref.iconColor,
      backgroundColor = _ref.backgroundColor,
      borderRadius = _ref.borderRadius,
      padding = _ref.padding,
      margin = _ref.margin;
    return (0, _styledComponents.css)(["cursor:pointer;border:0;background:none;padding:", ";margin:", ";box-sizing:content-box;color:", ";border-radius:", ";width:", "px;height:", "px;display:inline-flex;justify-content:center;align-items:center;&:hover{background:", ";}", ""], padding ? padding + "px" : (0, _spaceMixin.spaceMixin)('xs')(props), margin ? margin + "px" : "-" + (0, _spaceMixin.spaceMixin)('xs')(props), iconColor, borderRadius, buttonSize, buttonSize, backgroundColor, (0, _focusMixin.focusMixin)(props));
  })(props);
};
exports.CloseButtonMixin = CloseButtonMixin;